module.exports = __webpack_public_path__ + "assets/outdoor.fade2317363026c7c209a5a1c092da06.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/outdoor.jpg
// module id = 625
// module chunks = 0